import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const BUDGETS_API_PATH = '/api/budgets';

const getStores = () => axios.get(`${API_BASE_URL}${BUDGETS_API_PATH}/stores`);
const getPlans = (params = {}) => axios.get(`${API_BASE_URL}${BUDGETS_API_PATH}/plans`, { params });
const createPlan = (payload) => axios.post(`${API_BASE_URL}${BUDGETS_API_PATH}/plans`, payload);
const updatePlan = (planId, payload) => axios.put(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}`, payload);
const submitPlan = (planId, payload = {}) => axios.post(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/submit`, payload);
const rejectPlan = (planId, payload = {}) => axios.post(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/reject`, payload);
const approvePlan = (planId, payload = {}) => axios.post(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/approve`, payload);
const lockPlan = (planId, payload = {}) => axios.post(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/lock`, payload);
const reopenPlan = (planId, payload = {}) => axios.post(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/reopen`, payload);
const distributePlan = (planId, payload = {}) => axios.post(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/distribute`, payload);
const getTargets = (planId, params = {}) => axios.get(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/targets`, { params });
const upsertTargets = (planId, payload) => axios.put(`${API_BASE_URL}${BUDGETS_API_PATH}/plans/${planId}/targets`, payload);
const getPosSummary = (params = {}) => axios.get(`${API_BASE_URL}${BUDGETS_API_PATH}/pos-summary`, { params });
const getReport = (params = {}) => axios.get(`${API_BASE_URL}${BUDGETS_API_PATH}/reports`, { params });
const getAuditLogs = (params = {}) => axios.get(`${API_BASE_URL}${BUDGETS_API_PATH}/audit-logs`, { params });

const budgetService = {
  getStores,
  getPlans,
  createPlan,
  updatePlan,
  submitPlan,
  rejectPlan,
  approvePlan,
  lockPlan,
  reopenPlan,
  distributePlan,
  getTargets,
  upsertTargets,
  getPosSummary,
  getReport,
  getAuditLogs,
};

export default budgetService;
